'use strict';

angular.module('app.favorites', [])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.favorites', {
                url: '/favorites',
                templateUrl: 'components/favorites/favoritesView.html',
                fullWidth: true
            });
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/favorites/favorites.js